import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';
import {SubmissionSeries} from '../../../dashboard/symbols/submission-series.symbols';
import {SubmissionAdditionalDataMain, SubmissionAdditionalDataBackendModel} from '../../types';

/** Unique identifier for dashboard supplemental health state. */
export const dashboardSupplementalHealthStateUniqueIdentifier = '_DashboardSupplementalHealthSubmission_';

/** Describes a dashboard supplemental health state model. */
export interface DashboardSupplementalHealthStateModel {
  /** Contain a load current load submission additional data progress status. */
  loadSubmissionAdditionalDataStatus: PROGRESS_STATUSES;

  /** Contain the last error that occurs during the load submission additional data process. */
  lastLoadSubmissionAdditionalDataError: UnknownError;

  /** Contain load current manage submission additional data progress status. */
  manageSubmissionAdditionalDataStatus: PROGRESS_STATUSES;

  /** Contain the last error that occurs during manage submission additional data process. */
  lastManageSubmissionAdditionalDataError: UnknownError;

  /** Contain related account data to the currently managing submission additional data. */
  submissionAdditionalData: SubmissionAdditionalDataBackendModel;

  /** Contain the last stored submission series uid. */
  storedSubmissionSeriesUid: SubmissionSeries['id'];
}

/** Default values for dashboard supplemental health state. */
export const dashboardSupplementalHealthStateDefaults: DashboardSupplementalHealthStateModel = {
  loadSubmissionAdditionalDataStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastLoadSubmissionAdditionalDataError: null,
  manageSubmissionAdditionalDataStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastManageSubmissionAdditionalDataError: null,
  submissionAdditionalData: null,
  storedSubmissionSeriesUid: null,
};
